import { Header } from "components/elements";
import {
  CheckboxGroupField,
  TextFieldWithQuery,
  TextField,
} from "components/form/fields";
import { Column, Row, Section } from "components/layout";

import { ListField } from "../components";
import { TEXTS } from "../constants";
import { PROVIDER_FIELDS } from "../fields";
import { useProviderFieldUnique } from "../hooks";
import { ProviderForm } from "../types";

export function TiVoAppFormBaseTab() {
  const appNameUnique = useProviderFieldUnique({
    name: PROVIDER_FIELDS.BASE.APP_LABEL.name,
    notUniqueError: TEXTS.BASE.APP_LABEL_NOT_UNIQUE_ERROR,
    queryParamName: "exactLabel",
  });
  const providerIdUnique = useProviderFieldUnique({
    name: PROVIDER_FIELDS.BASE.PROVIDER_ID.name,
    notUniqueError: TEXTS.BASE.PROVIDER_ID_NOT_UNIQUE_ERROR,
  });

  return (
    <Section>
      <Row>
        <Column>
          <Header uppercase={true} bold={true} color="secondary">
            {TEXTS.BASE.BEGIN_HEADER}
          </Header>
          <TextFieldWithQuery
            {...PROVIDER_FIELDS.BASE.APP_LABEL}
            query={appNameUnique}
          />
          <TextField {...PROVIDER_FIELDS.BASE.DISPLAY_NAME} />
          <CheckboxGroupField {...PROVIDER_FIELDS.BASE.CATEGORY} />
        </Column>
        <Column>
          <Section header={TEXTS.BASE.ID_HEADER}>
            <TextFieldWithQuery
              {...PROVIDER_FIELDS.BASE.PROVIDER_ID}
              query={providerIdUnique}
            />
            <TextField {...PROVIDER_FIELDS.BASE.UNIVERSAL_PROVIDER_ID} />
            <ListField<NonNullable<ProviderForm["jwProviderId"]>[number]>
              {...PROVIDER_FIELDS.BASE.JW_PROVIDER_ID}
              template=""
            >
              {(field) => <TextField {...field} look="simple" />}
            </ListField>
          </Section>
        </Column>
      </Row>
      <Row>
        <Column>
          <Section header={TEXTS.BASE.ALLOW_LIST_HEADER}>
            <ListField<NonNullable<ProviderForm["allowList"]>[number]>
              {...PROVIDER_FIELDS.BASE.ALLOW_LIST}
              template=""
            >
              {(field) => (
                <TextField
                  {...field}
                  look="simple"
                  placeholder={TEXTS.BASE.REG_EXP_PLACEHOLDER}
                />
              )}
            </ListField>
          </Section>
        </Column>
      </Row>
    </Section>
  );
}
